import apiService from '../../services/api';
import { publicApi } from '../../services/publicApi';

// Small feature-focused helpers to avoid bloating generic API service

export async function clearAllCaches(): Promise<string> {
  const res = await apiService.clearCaches();
  return typeof res === 'string' ? res : res?.message || 'Caches cleared';
}

export async function warmPublicCaches(country: string = 'EST'): Promise<{ dashboard: any; timeline: any }> {
  // Hit public endpoints to repopulate cache; ignore failures individually
  const [dashboard, timeline] = await Promise.all([
    publicApi.getDashboardData(undefined, undefined, undefined, country).catch((e) => ({ error: String(e) })),
    publicApi.getTimelineData(undefined, undefined, undefined, country).catch((e) => ({ error: String(e) })),
  ]);
  return { dashboard, timeline };
}

export async function resetFailedJobs(includeStuck: boolean = false): Promise<{ failedReset: number; stuckReset: number; timestamp: string }> {
  const res = await apiService.post(`/api/admin/queue/reset-failed${includeStuck ? '?includeStuck=true' : ''}`);
  return res.data;
}

